<template>
  <div :id="$attrs['id']" :class="[$attrs['class'], gridClasses, 'variablecontent']">
    <slot v-if="visibleBreakpoint === 'mobile'" name="mobile" />
    <slot v-if="visibleBreakpoint === 'tablet'" name="tablet" />
    <slot v-if="visibleBreakpoint === 'desktop'" name="desktop" />
    <slot v-if="visibleBreakpoint === 'hd'" name="hd" />
    <slot v-if="visibleBreakpoint === null" />
  </div>
</template>

<script>

import breakpoints from '@/lib/breakpoints';
import { isNil, head, last } from 'lodash';
import GridMixin from '@/mixins/GridMixin';

export default {
  name: 'VariableContent',

  mixins: [GridMixin],

  props: {
  },

  data() {
    return {
      availableContent: {
      },
    };
  },

  computed: {
    visibleBreakpoint: function () {
      const activeBreakpoint = this.$store.getters['layout/activeBreakpoint'];

      if (this.availableContent[activeBreakpoint]) {
        return activeBreakpoint;
      }

      const breakpointIndex = breakpoints[activeBreakpoint].index;

      const self = this;
      let ret = head(
        Object.values(breakpoints)
          .sort((a, b) => a.index - b.index)
          .filter(entry => entry.index >= breakpointIndex)
          .filter(entry => self.availableContent[entry.name]),
      );

      if (isNil(ret)) {
        ret = last(
          Object.values(breakpoints)
            .sort((a, b) => a.index - b.index)
            .filter(entry => entry.index < breakpointIndex)
            .filter(entry => self.availableContent[entry.name]),
        );
      }

      return isNil(ret) ? null : ret.name;
    },
  },

  created: function () {
    const self = this;
    Object.keys(breakpoints).forEach((breakpointKey) => {
      self.availableContent[breakpointKey] = !isNil(self.$slots) && !isNil(self.$slots[breakpointKey]);
    });
  },

  methods: {
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .variablecontent {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: 1.5rem;
    grid-auto-rows: max-content;
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/VariableContent.vue